import React from "react";
import {
  Box,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from "@chakra-ui/react";
import { colors } from "../styles";
import { ColorIcon } from "./Icons";
import { BaseStack } from "../design-system";

export interface FAQQuestion {
  q: string;
  a: string;
}

export interface FAQSection {
  questions: FAQQuestion[];
}

interface FAQAccordionProps {
  sections: FAQSection[];
  defaultIndex?: number[];
}

export const FAQAccordion: React.FC<FAQAccordionProps> = ({
  sections,
  defaultIndex = [0],
}) => {
  // sections를 flatten하여 모든 질문을 하나의 배열로
  const allQuestions = sections.flatMap((section) => section.questions);

  return (
    <Accordion allowMultiple defaultIndex={defaultIndex} width="100%">
      {allQuestions.map((item, questionIndex) => (
        <AccordionItem
          key={questionIndex}
          border="none"
          borderBottom={
            questionIndex === allQuestions.length - 1
              ? "none"
              : `1px solid ${colors.gray200}`
          }
        >
          {({ isExpanded }) => (
            <>
              <AccordionButton
                padding="14px 0"
                _hover={{ background: "transparent" }}
              >
                <BaseStack
                  direction="horizontal"
                  width="100%"
                  spacing={8}
                  alignItems="flex-start"
                  flex={1}
                >
                  <Box className="body_16_m gray500" flexShrink={0}>
                    Q
                  </Box>
                  <Box className="body_16_m gray900" flex={1} textAlign="left">
                    {item.q}
                  </Box>
                </BaseStack>
                <ColorIcon
                  name={isExpanded ? "chevron_up_24" : "chevron_down_24"}
                  color={colors.gray400}
                  size={20}
                />
              </AccordionButton>
              <AccordionPanel
                padding="0 28px 14px 28px"
                backgroundColor={colors.white}
              >
                <BaseStack
                  direction="horizontal"
                  width="100%"
                  spacing={8}
                  alignItems="flex-start"
                >
                  <Box className="body_14_r orange650" flexShrink={0}>
                    A
                  </Box>
                  <Box
                    className="body_14_r gray700"
                    flex={1}
                    whiteSpace="pre-line"
                  >
                    {item.a}
                  </Box>
                </BaseStack>
              </AccordionPanel>
            </>
          )}
        </AccordionItem>
      ))}
    </Accordion>
  );
};
